module.exports = __webpack_public_path__ + "static/media/fav-img1.426d9363.png";